var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isHitPhoneEnabled)?_c('div',[_c('button',{staticClass:"text-slate-600 mb-4 dark:text-slate-100 w-10 h-10 my-1 p-0 flex items-center justify-center rounded-lg hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600 relative",class:{
      'bg-woot-50 dark:bg-slate-800 text-woot-500 hover:bg-woot-50':
        _vm.isOpenDialPad,
    },on:{"click":_vm.toggleDialPad}},[_c('fluent-icon',{class:{
        'text-woot-500': _vm.isOpenDialPad,
      },attrs:{"icon":"dial-pad"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }